import { Link } from 'react-router-dom'
import styled from '@mui/material/styles/styled'
import { buttonCss } from './StyledButton.style'

export const StyledLinkAsButton = styled(Link, {
  shouldForwardProp: (prop) =>
    prop !== 'variant' &&
    prop !== 'filltype' &&
    prop !== 'parentbg' &&
    prop !== 'external' &&
    prop !== 'name' &&
    prop !== 'fullwidth'
})(buttonCss)
